import SortDirectionControl from './SortDirectionControl';
import React from 'react';
import { Popover, Button, Icon, DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

export const FoundAtFilter = ({ onChange, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const onDateChange = (dates, _dateStrings) => {
    if (dates) {
      if (dates.length > 0) {
        onChange({
          ...params,
          foundAtStart: moment(dates[0]).format('yyyy-MM-DD kk:mm:ss'),
          foundAtEnd: moment(dates[1]).format('yyyy-MM-DD kk:mm:ss')
        });
      } else {
        onChange({
          ...params,
          foundAtStart: null,
          foundAtEnd: null
        });
      }
    } else {
      onChange({
        ...params,
        foundAtStart: null,
        foundAtEnd: null
      });
    }
  };

  const content = (
    <>
      <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        <SortDirectionControl order={params?.order} />
      </div>
      <RangePicker
        placement='topLeft'
        format='DD/MM/YYYY hh:mm A'
        showTime={{ use12Hours: true }}
        onChange={onDateChange}
      />
    </>
  );

  return (
    <Popover content={content} title='Found At' trigger='click'>
      <Button className='sighting-filter' style={{ width: '8%' }}>
        Found At
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
